export default "__VITE_ASSET__DScca1eu__"